import styled from "styled-components";
import {
  Accordion,
  Container,
  TextField,
  Typography,
} from "@mui/material";

import SearchIcon from "../../../../../assets/images/search-icon.svg";

interface TitleProps {
  $isexpanded: boolean;
}

const primaryColor = "#0b234c";
const expandedColor = "#001e64";
const backgroundColor = "#f7f7f5";
const accentColor = "#ff5000";

export const Wrapper = styled.section`
  && {
    width: 100%;
    background: ${backgroundColor};
    padding-top: 2rem;
  }
`;

export const CustomContainer = styled(Container)`
  && {
    display: flex;
    flex-direction: column;
    padding: 20px 20px 50px;
  }

  @media screen and (max-width: 900px) {
    && {
      padding: 20px 16px 120px;
    }
  }

  @media screen and (max-width: 480px) {
    && {
      padding: 20px 16px 80px;
    }
  }
`;

export const MainTitle = styled(Typography)`
  && {
    width: 100%;
    margin: 0 0 2rem;

    color: ${primaryColor};
    font-family: Figtree, sans-serif;
    font-weight: 700;
    font-size: clamp(2rem, 4vw + 1rem, 3.625rem);
    line-height: 1.15;
  }

  @media screen and (max-width: 900px) {
    && {
      text-align: center;
    }
  }
`;

export const CustomAccordion = styled(Accordion)`
  && {
    margin-bottom: 10px;
    padding: 10px;

    background: #ffffff;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }

  &&::before {
    display: none;
  }

  &&.Mui-expanded {
    margin: 0 0 10px;
  }

  && .MuiAccordionSummary-root {
    min-height: 48px;
    padding: 0 8px;
  }

  && .MuiAccordionSummary-root.Mui-expanded {
    min-height: 48px;
  }

  && .MuiAccordionSummary-content {
    margin: 12px 0;
  }

  && .MuiAccordionSummary-content.Mui-expanded {
    margin: 12px 0;
  }

  && .MuiAccordionDetails-root {
    padding: 8px 8px 16px;
  }

  && .MuiAccordionSummary-expandIconWrapper {
    color: ${accentColor};
  }

  @media screen and (max-width: 900px) {
    && {
      background: transparent;
      border-bottom: 1px solid #d2d2d2;
      padding: 10px 0;
    }

    && .MuiAccordionSummary-root {
      padding: 0;
    }

    && .MuiAccordionDetails-root {
      padding: 8px 0 16px;
    }
  }
`;

export const Title = styled(Typography)<TitleProps>`
  && {
    margin: 0;

    color: ${({ $isexpanded }) =>
      $isexpanded ? expandedColor : primaryColor};

    font-family: Figtree, sans-serif;
    font-weight: ${({ $isexpanded }) => ($isexpanded ? 700 : 400)};
    font-size: 1.2rem;
    line-height: 1.4;
  }

  @media screen and (max-width: 480px) {
    && {
      font-size: 0.95rem;
    }
  }
`;

export const SubTitle = styled(Typography).attrs({ as: "p" })`
  && {
    margin: 0;

    color: rgba(60, 60, 67, 0.85);
    font-family: Figtree, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
  }
`;

export const SearchInput = styled(TextField)`
  && {
    width: 100%;
    margin-bottom: 25px;
    padding: 0 10px;

    background-color: #ffffff;
    border-radius: 8px;
  }

  && .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  && .MuiInputLabel-formControl {
    font-family: Figtree, sans-serif;
    font-size: 20px;
  }

  && .MuiInputBase-formControl {
    font-family: Figtree, sans-serif;
    font-size: 20px;
  }

  && .MuiInputBase-input::placeholder {
    color: #979797;
    opacity: 1;
  }
`;

export const SearchInputIcon = styled.span`
  && {
    display: inline-block;
    width: 30px;
    height: 30px;

    background-image: url(${SearchIcon});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
`;

export const ActionButton = styled.a`
  && {
    display: none;
    justify-content: center;
    align-items: center;

    margin-top: 20px;
    padding: 15px 30px;

    background: ${accentColor};
    color: #ffffff;

    font-family: Figtree, sans-serif;
    font-weight: 600;
    text-decoration: none;

    cursor: pointer;
  }

  &&:hover {
    background: #e54800;
  }

  &&:focus-visible {
    outline: 2px solid ${primaryColor};
    outline-offset: 2px;
  }

  @media screen and (max-width: 900px) {
    && {
      display: flex;
      width: 100%;
    }
  }
`;

export const TableTitle = styled(Typography).attrs({ as: "p" })`
  && {
    margin: 0;

    color: #ffffff;
    font-family: Figtree, sans-serif;
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
  }
`;